<template lang="pug">
.page_404
  .text.text-center
    h1 404
    p 您要找的資訊已搬遷至新版官網囉!
    p.count {{ countNum }}
      span 秒後將自動返回
  img.d-lg-none(:src="bg404")
</template>

<script>
import bg404 from "@/assets/img/media/404.png";

export default {
  name: "Page404",
  data() {
    return {
      bg404,
      countNum: 3,
      timer: null,
    };
  },
  mounted() {
    this.timer = setInterval(this.countdown, 1000);
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    countdown() {
      if (this.countNum > 0) {
        this.countNum--;
      }

      if (this.countNum == 0) {
        clearInterval(this.timer);
        this.$router.push({
          name: "Home",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page_404 {
  width: 100%;
  height: calc(100vh - 95px);
  background-image: url("~@/assets/img/media/404.png");
  background-position: right bottom;
  background-repeat: no-repeat;
  background-size: 1029px;
  padding-top: 120px;
}

.text {
  margin-left: 13%;
  width: fit-content;
}

h1 {
  font-size: 150px;
  font-weight: 600;
  color: $color_blue_ci;
}

p {
  font-size: 22px;
  color: $color_black_text;
}

p.count {
  color: $color_blue_btn_ci;

  span {
    color: $color_black_text;
  }
}

@media (max-width: 991px) {
  .page_404 {
    height: auto;
    background-size: 100%;
    padding-top: 74px;
    background-image: none;
    padding-bottom: 92px;
  }

  .text {
    margin-left: 12%;
  }

  h1 {
    font-size: 144px;
  }

  p {
    font-size: 18px;
  }

  img {
    width: 100%;
    height: auto;
  }
}

@media (max-width: 767px) {
  .page_404 {
    height: auto;
    padding-top: 0;
    padding-bottom: 49px;
  }

  .text {
    margin-left: 0;
    width: 100%;
  }

  h1 {
    font-size: 180px;
  }

  p {
    font-size: 24px;
  }

  img {
    width: 100%;
    height: auto;
    margin-top: 65px;
  }
}

@media (max-width: 575px) {
  .page_404 {
    padding-bottom: 8.5vw;
  }

  h1 {
    font-size: 31vw;
  }

  p {
    font-size: 4.1vw;
  }

  img {
    width: 100%;
    height: auto;
    margin-top: 11vw;
  }
}
</style>
